import './App.css';
import Lightning from './world/AmbientLight'
import Camera from './world/Camera';
import Box from './objects/Box'
import Plane from './objects/Plane'
import Cylinder from './objects/Cylinder'
import { OrbitControls, Stars, Environment } from '@react-three/drei';
import Effects from './world/Effects'
import { useEffect } from 'react';

const App = () => {
  return (
    <>
      <fog color="#000" far={20000}/>
      <Camera />
      <OrbitControls />
      <Environment files="textures/studio.hdr" />
      <Lightning args={[0xffffbb, 0x080820, 1]}/>
      <Box position={[0, 0, 0]}/>
    </>
  );
}

export default App;
